// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-table[data-v-bfea1d8a] {\n  padding-left: 30px;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
